'use strict';
(() => {
  const headerDetails = () => [...document.querySelectorAll('[data-header-details]')];
  const syncPanels = () => {
    const header = document.querySelector('#shopify-section-header');
    if (header) document.documentElement.style.setProperty('--header-panel-offset', `${Math.max(0, header.getBoundingClientRect().bottom)}px`);
    document.body.classList.toggle('jmo-panel-open', headerDetails().some(panel => panel.open));
  };
  function closePanel(panel, focus = false) {
    panel.open = false;
    syncPanels();
    if (focus) panel.querySelector('summary')?.focus();
  }
  function initializePanels() {
  headerDetails().forEach(panel => {
    if (panel.dataset.jmoPanelReady) return;
    panel.dataset.jmoPanelReady = 'true';
    panel.addEventListener('toggle', () => {
      syncPanels();
      if (!panel.open) return;
      headerDetails().forEach(other => { if (other !== panel) closePanel(other); });
      panel.querySelector('input[type="search"]')?.focus();
    });
  });
  syncPanels();
  }
  initializePanels();
  document.addEventListener('shopify:section:load', initializePanels);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(syncPanels));
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-close-details]');
    if (button) closePanel(button.closest('details'), true);
    else headerDetails().forEach(panel => { if (panel.open && !panel.contains(event.target)) closePanel(panel); });
  });
  document.addEventListener('keydown', event => {
    const open = headerDetails().find(panel => panel.open);
    if (!open) return;
    if (event.key === 'Escape') { event.preventDefault(); closePanel(open, true); }
    if (event.key === 'Tab') {
      const controls = [...open.querySelectorAll('summary,a[href],button,input,select,textarea')].filter(el => !el.disabled && el.getClientRects().length);
      const first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    }
  });
  const header = document.querySelector('#shopify-section-header');
  if (header && 'ResizeObserver' in window) new ResizeObserver(() => document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`)).observe(header);

  const navigationKey = 'jmo-shopify-navigation-v1';
  const route = location.pathname + location.search;
  let stack = [];
  try {
    stack = JSON.parse(sessionStorage.getItem(navigationKey) || '[]');
    if (!Array.isArray(stack)) stack = [];
    stack = stack.filter(value => typeof value === 'string' && value.startsWith('/') && !value.startsWith('//'));
    const isBackForward = performance.getEntriesByType('navigation')[0]?.type === 'back_forward';
    const priorIndex = stack.lastIndexOf(route);
    if (isBackForward && priorIndex >= 0) stack = stack.slice(0, priorIndex + 1);
    else if (stack[stack.length - 1] !== route) stack.push(route);
    stack = stack.slice(-30);
    sessionStorage.setItem(navigationKey, JSON.stringify(stack));
  } catch { stack = []; }
  document.querySelectorAll('[data-jmo-back]').forEach(link => {
    link.addEventListener('click', event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button) return;
      if (stack.length < 2) return;
      event.preventDefault();
      const previous = stack[stack.length - 2];
      try { sessionStorage.setItem(navigationKey, JSON.stringify(stack.slice(0, -1))); } catch { /* Normal navigation still works. */ }
      location.assign(previous);
    });
  });

  document.addEventListener('visibilitychange', () => document.body.classList.toggle('jmo-tab-hidden', document.hidden));
  const params = new URLSearchParams(location.search);
  const piece = (params.get('piece') || params.get('product') || '').slice(0,200);
  if (piece) document.querySelectorAll('[data-piece-request]').forEach(input => { if (!input.value) input.value = piece; });
})();
